import { withInstall } from '@ll-plus/utils'

import Html from './src/html.vue'

export const LlHtml = withInstall(Html)
export default LlHtml
export * from './src/html'

declare module 'vue' {
  export interface GlobalComponents {
    LlHtml: typeof Html
  }
}
